export const SET_AGENCIES_GRID_SORT_CRITERIA = '[Agencies] SET_AGENCIES_GRID_SORT_CRITERIA';
export const SET_CURRENT_SELECTED_AGENCY = '[Agencies] SET_CURRENT_SELECTED_AGENCY';
export const SET_AGENCIES_FILTERS = '[Agencies] SET_AGENCIES_FILTERS';
export const RESET_AGENCIES_FILTERS = '[Agencies] RESET_AGENCIES_FILTERS';
export const SET_CREDENTIALS_GRID_SORT_CRITERIA = '[Agencies] SET_CREDENTIALS_GRID_SORT_CRITERIA';
export const SET_PROFILE_FORM_IS_EDITABLE = '[Agencies] SET_PROFILE_FORM_IS_EDITABLE';
export const SET_PROFILE_FORM_IS_NOT_EDITABLE = '[Agencies] SET_PROFILE_FORM_IS_NOT_EDITABLE';
export const SET_PROFILE_FORM_IS_LOADING = '[Agencies] SET_PROFILE_FORM_IS_LOADING';
export const SET_PROFILE_FORM_IS_NOT_LOADING = '[Agencies] SET_PROFILE_FORM_IS_NOT_LOADING';
export const FETCH_AGENCIES_LIST = '[Agencies] FETCH_AGENCIES_LIST';
export const SAVE_AGENCIES_LIST = '[Agencies] SAVE_AGENCIES_LIST';
export const SET_AGENCIES_LIST_IS_LOADING = '[Agencies] SET_AGENCIES_LIST_IS_LOADING';
export const SET_AGENCIES_LIST_IS_NOT_LOADING = '[Agencies] SET_AGENCIES_LIST_IS_NOT_LOADING';
export const UPDATE_AGENCY_INFO = '[Agencies] UPDATE_AGENCY_INFO';
export const FETCH_AGENCY_CREDENTIALS = '[Agencies] FETCH_AGENCY_CREDENTIALS';
export const SAVE_AGENCY_CREDENTIALS = '[Agencies] SAVE_AGENCY_CREDENTIALS';
export const SET_CURRENT_SELECTED_CREDENTIAL = '[Agencies] SET_CURRENT_SELECTED_CREDENTIAL';
export const SET_AGENCIES_CREDENTIALS_LIST_IS_LOADING =
  '[Agencies] SET_AGENCIES_CREDENTIALS_LIST_IS_LOADING';
export const SET_AGENCIES_CREDENTIALS_LIST_IS_NOT_LOADING =
  '[Agencies] SET_AGENCIES_CREDENTIALS_LIST_IS_NOT_LOADING';
export const SET_SHOW_CREDENTIAL_FORM = '[Agencies] SET_SHOW_CREDENTIAL_FORM';
export const SET_HIDE_CREDENTIAL_FORM = '[Agencies] SET_HIDE_CREDENTIAL_FORM';
export const SET_CREDENTIAL_FORM_UPDATE_MODE = '[Agencies] SET_CREDENTIAL_FORM_UPDATE_MODE';
export const SET_CREDENTIAL_FORM_CREATE_MODE = '[Agencies] SET_CREDENTIAL_FORM_CREATE_MODE';
export const SET_CREDENTIAL_FORM_IS_LOADING = '[Agencies] SET_CREDENTIAL_FORM_IS_LOADING';
export const SET_CREDENTIAL_FORM_IS_NOT_LOADING = '[Agencies] SET_CREDENTIAL_FORM_IS_NOT_LOADING';
export const FETCH_SAVE_CREDENTIAL = '[Agencies] FETCH_SAVE_CREDENTIAL';
